// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth, GoogleAuthProvider} from 'firebase/auth'
import { getStorage } from "firebase/storage";
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBlybtnukJ6M7LqoTMiWJup68XTsfgkzRM",
  authDomain: "kornik-1lo.firebaseapp.com",
  projectId: "kornik-1lo",
  storageBucket: "kornik-1lo.appspot.com",
  messagingSenderId: "466142822838",
  appId: "1:466142822838:web:18e1de2e9a674ddaa64117",
  measurementId: "G-SB1CGHZ9S2"
};


// Import the functions you need from the SDKs you need
/*import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from 'firebase/firestore'
import {getAuth, GoogleAuthProvider} from 'firebase/auth'
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBjYGFUmZLlMJS-wBam827SQisEpDiqbJ4",
  authDomain: "snf-backup.firebaseapp.com",
  projectId: "snf-backup",
  storageBucket: "snf-backup.appspot.com",
  messagingSenderId: "307483074037",
  appId: "1:307483074037:web:5b9f0fe9a8c069c64d14bc",
  measurementId: "G-FNW4X81QZX"
};*/

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
